<template>
    <div>
        <template v-if="parts">
            <v-client-table :columns="columns" :options="options" :data="parts">

                <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                </div>

                <div slot="afterFilter" class="ml-2">
                    <button class="btn btn-warning" v-on:click="sendToPrint()" title="Printable Friendly List">
                        <i class="fas fa-print"></i>
                    </button>
                    <button class="btn btn-success" v-on:click="exportList()" title="Export Parts List">
                        <i class="fas fa-file-excel"></i>
                    </button>
                </div>

                <template slot="id" slot-scope="props">
                    <router-link :to="`/parts/${props.row.id}`" class="btn btn-sm btn-default" title="View Part"><i class="fas fa-eye"></i></router-link>

                    <b-dropdown text="Left align" variant="default" no-caret size="sm"  v-if="mfgId">
                        <template v-slot:button-content>
                            <i class="fas fa-ellipsis-h"></i>
                        </template>
                        <b-dropdown-item href="javascript:void(0)" v-on:click="$router.push(`/parts/${props.row.id}/mfg/${mfgId}`)"><i class="fas fa-edit"></i> Edit</b-dropdown-item>
                        <b-dropdown-item href="javascript:void(0)" v-on:click="$router.push(`/parts/${props.row.id}/mfg/${mfgId}/delete`)"><i class="fas fa-trash text-danger"></i> Delete</b-dropdown-item>
                    </b-dropdown>
                </template>

                <template slot="part_nbr" slot-scope="props">
                    <router-link :to="`/parts/${props.row.id}`" title="View Part">{{ props.row.part_nbr }}</router-link>
                </template>

                <template slot="customer_name" slot-scope="props" v-if="!customerId">
                    <router-link :to="`/customers/${props.row.customer_id}`" title="View Customer">{{ props.row.customer_name }}</router-link>
                </template>

                <template slot="created_at" slot-scope="props">
                    {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                </template>
            </v-client-table>
        </template>
        <template v-else>
            <v-server-table ref="partTable" url="/parts" :columns="columns" :options="options">

                <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                </div>

                <div slot="afterFilter" class="ml-2">
                    <button class="btn btn-default" v-on:click="clearFilters()" title="Clear All Filters">
                        <i class="fas fa-ban"></i>
                    </button>
                    <button class="btn btn-default" v-on:click="showFilters = !showFilters" title="Apply Filters">
                        <i class="fas fa-filter"></i>
                        <span class="badge badge-danger" v-if="filterCount > 0">{{ filterCount }}</span>
                    </button>
                    <button class="btn btn-warning" v-on:click="sendToPrint()" title="Printable Friendly List">
                        <i class="fas fa-print"></i>
                    </button>
                    <button class="btn btn-success" v-on:click="exportList()" title="Export Parts List">
                        <i class="fas fa-file-excel"></i>
                    </button>
                </div>

                <template slot="id" slot-scope="props">
                    <router-link :to="`/parts/${props.row.id}`" class="btn btn-sm btn-secondary" title="View Part">View</router-link>
                </template>

                <template slot="part_nbr" slot-scope="props">
                    <router-link :to="`/parts/${props.row.id}`" title="View Part">{{ props.row.part_nbr }}</router-link>
                </template>

                <template slot="customer_name" slot-scope="props" v-if="!customerId">
                    <router-link :to="`/customers/${props.row.customer_id}`" title="View Customer">{{ props.row.customer_name }}</router-link>
                </template>

                <template slot="created_at" slot-scope="props">
                    {{ props.row.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                </template>
            </v-server-table>
        </template>

        <b-modal v-model="showFilters" title="Part Filters" size="lg" no-fade ok-title="Apply Filters" @ok="applyFilters()">
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Customer:</div>
                <div class="col-md-7 col-12">
                    <v-select
                        v-model="filters['parts.customer_id']"
                        :options="filterData.customers"
                        :reduce="customer => customer.id"
                        label="customer_name"
                        placeholder="-- Select a Customer --"
                        multiple ></v-select>

                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">MFG Location:</div>
                <div class="col-md-7 col-12">
                    <v-select
                        v-model="mfg_location_id"
                        :options="filterData.mfgs"
                        :reduce="mfg => mfg.id"
                        label="mfg_location_name"
                        placeholder="-- Select an MFG Location --"></v-select>

                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Include Archived Parts:</div>
                <div class="col-md-7 col-12">
                    <b-form-checkbox v-model="filters['parts.deleted_at']" :value="true" :unchecked-value="null" plain></b-form-checkbox>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            parts: {
                type: Array,
                default: null,
            },

            customerId: {
                type: Number,
                default: null
            },

            mfgId: {
                type: Number,
                default: null
            }
        },

        data() {
            return {
                showFilters: false,
                mfg_location_id: null,
                options: {
                    headings: {
                        id: 'Actions',
                        part_nbr: 'Part#',
                        customer_name: 'Customer',
                        description: 'Desc',
                        color_code: 'Color',
                        sequence_location: 'Sequence',
                        line_location_name: 'Line Loc.',
                        model: 'Model',
                    },
                    texts:{
                        filterPlaceholder:"Search Parts",
                    },
                    orderBy: {
                        ascending: true,
                        column: 'customers.customer_name',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('partListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Add the type
                        data.filters = this.filters;

                        //Set it
                        if(this.mfg_location_id)
                        {
                            data.mfg_id = this.mfg_location_id;
                        }

                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },

                filters: {
                    'parts.customer_id': [],
                    'parts.deleted_at': null,
                },
            }
        },

        computed: {
            columns(){
                //Default
                var cols = ['id', 'part_nbr', 'customer_name']

                //Check for a customer
                if(this.customerId)
                {
                    cols = ['id', 'part_nbr']
                }

                //Add All other COlumsn
                cols.push('description');
                cols.push('color_code');

                //check for MFG
                if(this.mfgId || this.mfg_location_id)
                {
                    cols.push('sequence_location');
                    cols.push('line_location_name');
                    cols.push('model');
                }

                //Sned it
                return cols;
            },

            filterData(){
                //Send it
                return this.$store.state.partFilters ? this.$store.state.partFilters : {};
            },

            filterCount(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(Array.isArray(this.filters[keys[i]]) && this.filters[keys[i]].length > 0)
                    {
                        count++;
                    }
                    else if(this.filters[keys[i]] != null && this.filters[keys[i]] != '')
                    {
                        count++;
                    }
                }

                //Send it
                return count;
            },
        },

        methods: {
            getFilters(){
                //Check the store for the filters
                if(this.$store.state.partFilters)
                {
                    //Stop here
                    return;
                }

                //Send it
                this.$http.get('/parts/resources')
                    .then(response => {
                        //Commmit
                        this.$store.commit('partFilters', response.data);
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            clearFilters(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(Array.isArray(this.filters[keys[i]]))
                    {
                        this.filters[keys[i]] = [];
                    }
                    else
                    {
                        this.filters[keys[i]] = null;
                    }
                }

                //Refresh
                this.$refs.partTable.refresh();
            },

            applyFilters(){
                //Apply the filters
                this.$refs.partTable.refresh();
            },

            editMfgPart(partId){
                //Broadcast the event
                this.$emit('editMfgPartEvt', partId);
            },

            deleteMfgPart(partId){
                //Broadcast the event
                this.$emit('deleteMfgPartEvt', partId);
            },

            sendToPrint(){
                //Send to a NEW print version
                var url = '/parts/print?';

                //Build it
                if(this.mfg_location_id)
                {
                    url += 'mfg_location_id=' + this.mfg_location_id + '&';
                }
                //Build it
                else if(this.mfgId)
                {
                    url += 'mfg_location_id=' + this.mfgId + '&';
                }

                //Loop and build ALL
                var keys = Object.keys(this.filters);

                //Loop it
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Append
                    if(Array.isArray(this.filters[keys[i]]))
                    {
                        //Make sure it's not empty
                        if(this.filters[keys[i]].length > 0)
                        {
                            //Build it
                        }
                    }
                    else if(this.filters[keys[i]])
                    {
                        //Append
                        url += keys[i] + '=' + this.filters[keys[i]] + '&';
                    }
                }

                //Send to the path
                window.open(url);
            },

            exportList(){
                //Send to a NEW print version
                var url = '/parts/export?';

                //Build it
                if(this.mfg_location_id)
                {
                    url += 'mfg_location_id=' + this.mfg_location_id + '&';
                }
                //Build it
                else if(this.mfgId)
                {
                    url += 'mfg_location_id=' + this.mfgId + '&';
                }

                //Loop and build ALL
                var keys = Object.keys(this.filters);

                //Loop it
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Append
                    if(Array.isArray(this.filters[keys[i]]))
                    {
                        //Make sure it's not empty
                        if(this.filters[keys[i]].length > 0)
                        {
                            //Build it
                        }
                    }
                    else if(this.filters[keys[i]])
                    {
                        //Append
                        url += keys[i] + '=' + this.filters[keys[i]] + '&';
                    }
                }

                //Send to the path
                window.open(url);
            },
        },

        mounted() {
            //Get the filtes
            this.getFilters();
        }
    }
</script>
